import { type FC } from 'react';

import { useApplicationContext } from '../../../../../../utils/applicationContext';
import { getCianMortgageBannerUrl } from '../../../../utils/getCianMortgageBannerUrl';
import { CianMortgageText } from '../../../MortgageOffersTable';

export const CianMortgageTextContainer: FC = () => {
  const { config } = useApplicationContext();

  const cianMortgageUrl = getCianMortgageBannerUrl(config);

  return <CianMortgageText cianMortgageUrl={cianMortgageUrl} />;
};
